import { cliSimpleGit } from '../cli-simple-git.js';

/** Returns the current branch name, or null when detached / unavailable. */
export async function getCurrentBranch(repoPath: string): Promise<string | null> {
  try {
    const git = cliSimpleGit(repoPath);
    const branch = await git.revparse(['--abbrev-ref', 'HEAD']);
    const trimmed = typeof branch === 'string' ? branch.trim() : '';
    if (!trimmed || trimmed === 'HEAD') return null;
    return trimmed;
  } catch {
    return null;
  }
}
